module.exports = __webpack_public_path__ + "static/media/login-background.787fbc9a.svg";